import { render, staticRenderFns } from "./BtnDownloadModelo.vue?vue&type=template&id=7f37b678"
import script from "./BtnDownloadModelo.vue?vue&type=script&lang=js"
export * from "./BtnDownloadModelo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports